import zhCN from './json/redpack-rain.zh_CN.json';
import zhTW from './json/redpack-rain.zh_TW.json';
import en from './json/redpack-rain.en.json';
import ja from './json/redpack-rain.ja.json';
import ko from './json/redpack-rain.ko.json';
import ru from './json/redpack-rain.ru.json';
export default {
  zh_CN: zhCN,
  zh_TW: zhTW,
  en,
  ja,
  ko,
  ru
};
